<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br /> {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br /> Date: {{ date }}
        </p>
        <p> RE: Account #: {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }} </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            I have received your attempt to validate the debt regarding the account# {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}. Thank you for sending this information. However, after reviewing the information you sent me, I must inform you that you have failed to validate this debt. Your office hasn’t sent any portion of what appears to be acceptable documentation so you have not yet provided sufficient evidence, per the FDCPA and as required, that this alleged debt is accurate and mine.
        </p>
        <ol>
            <strong>You DID NOT SEND:</strong>
            <li class="letter-content">
                Complete payment history, including but not limited to, verification by line item (with an explanation of each item) for the entire amount, dates of execution, as well as last date of activity. This requirement was established by Kenneth Wilber USCA-02-C-0072
            </li>
            <li class="letter-content"> Proof of my identity </li>
            <li class="letter-content">
                Proof that {{ lodash.head(lodash.map(accounts, 'furnisher_name')) }} owns this debt or the Contract giving you power to collect
            </li>
            <li class="letter-content">
                Proof that this debt has not been written off as a tax liability
            </li>
            <li class="letter-content">
                In addition, I've recently learned that you're required to send me notification of this debt and your plans to report it to the credit bureaus prior to doing so. YOU NEVER DID THAT! And if you think you did, then you must also send me proof that you did.
            </li>
            <li class="letter-content">
                As you can see, your company has clearly failed to send the legally required validation of this debt. So I would suggest you go ahead and remove this account from my credit file right away. Please send notice immediately once you’ve updated your records and have removed me from your files.
            </li>
            <li class="letter-content">
                For the purposes of 15 U.S.C. § 1692 et seq., this Notice has the same effect as a dispute to the validity of the alleged debt and a dispute to the validity of your claims. This Notice is an attempt to correct your records, and any information received from you will be collected as evidence should any further action be necessary. All future communications with me must be done in writing for tracking purposes and sent to the address noted in this letter.
            </li>
        </ol>
        <p>
            Thank you and I look forward to your resolving this mistake most expeditiously.
            <br />
            <br /> {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br />
            <strong>cc:  FTC; U.S. Attorney General; BBB; Consumer Action; Consumer Federation of America; Consumer Reports</strong>
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>